module.exports = __webpack_public_path__ + "static/img/menage1b.b4441b58.png";